import { call, delay, put, takeLatest } from 'redux-saga/effects';
import productApis from './apis';
import { actions } from './slice';
import { ISagaFunc } from 'services/actionConfigs';
import { GetProductListAction } from './constants';
import shopService from 'modules/shop/services';

const getCategoryList: ISagaFunc = function* () {
  yield delay(200);
  try {
    const response = yield call(productApis.category.getAll);
    yield put(actions.async.getCategoryList.success(response.data.data));
    yield put(shopService.actions.async.getCategories.success(response.data.data));
  } catch (error) {
    yield put(actions.async.getCategoryList.fail({}));
  }
};
const getProductList: ISagaFunc<GetProductListAction> = function* ({ payload }) {
  yield delay(200);
  try {
    const response = yield call(productApis.product.getList, payload);
    yield put(actions.async.getProductList.success(response.data.data));
  } catch (error) {
    yield put(actions.async.getProductList.fail({}));
  }
};

export default function* sagas() {
  yield takeLatest(actions.async.getCategoryList.fetch, getCategoryList);
  yield takeLatest(actions.async.getProductList.fetch, getProductList);
}
